import { render, staticRenderFns } from "./SubPagesNavigation.vue?vue&type=template&id=7f058b50&"
import script from "./SubPagesNavigation.vue?vue&type=script&lang=ts&"
export * from "./SubPagesNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./SubPagesNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports